







































































































































































































































































































import _ from 'lodash'
import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import RecebimentoStore from '@/components/Recebimento/Store/RecebimentoStore'
import Theme from '@/styles/Theme'
import { Recebimento } from '@/types/_'
import EventBus from '@/plugins/EventBus'
import Apis from '@/Apis/_'
import { maskDate, timeout, maskMoney, maskDateTime, maskDateMonth } from '@/utils/common'
import ChatFinanceiroStore from '@/components/financeiro-chat/store/chat-financeiro-store'

@Component

export default class ComponentRecebimentoItem extends Vue {
  @Prop() recebimento: Recebimento
  @Prop() id: string
  @Prop({ required: true, default: false }) disabled: boolean

  $refs!: {
    documentos: any,
  }

  loadDeletar: any = null
  loadAnexo: boolean = false
  loadValores: boolean = false
  loadingDeletarDocumento: any = null
  valoresList: boolean = false
  loadingDownloadNf: any = null
  mostrarArquivosPagos: boolean = false
  notasFiscaisExcluiveis: string[] = []

  ga(event: string, action: string) {
    this.$ga.event(event, action, this.$user.profile.email)
  }

  get valoresCalculados() {
    return this.getRecebimentoStore.valoresCalculados
  }

  get valorLiquido() {
    return this.getRecebimentoStore.valorLiquido
  }

  get valoresCalculadosHeader() {
    return [
      { text: 'Descrição', value: 'descricao', sortable: false, align: 'center' },
      { text: 'Valor total', value: 'valorTotal', sortable: false, align: 'center' },
    ]
  }

  get loadingValores() {
    return this.loadValores
  }

  set loadingValores(value: boolean) {
    this.loadValores = value
  }

  get valoresListDialog() {
    return this.valoresList
  }

  set valoresListDialog(value: boolean) {
    this.valoresList = value
  }

  get loadingDeletar() {
    return this.loadDeletar
  }

  set loadingDeletar(value: any) {
    this.loadDeletar = value
  }

  set loadingAnexo(value: boolean) {
    this.loadAnexo = value
  }

  get loadingAnexo() {
    return this.loadAnexo
  }

  get getRecebimento() {
    return this.recebimento
  }

  get getTheme() {
    return Theme
  }

  get getRecebimentoStore() {
    return getModule(RecebimentoStore, this.$store)
  }

  get getRequestMessage() {
    return this.getRecebimentoStore.requestMessage
  }

  get totalDocumentosAdicionais() {
    return this.getRecebimento.documentosAdicionais ? this.getRecebimento.documentosAdicionais.length : 0
  }

  // A regra (autor da nota ou gestor, e situação do repasse) é do backend; aqui só se consulta o resultado (FXSR-3202).
  podeExcluirNotaFiscal(arquivo: { documentoId: string }) {
    return this.notasFiscaisExcluiveis.includes(arquivo.documentoId)
  }

  @Watch('recebimento.notasFiscais', { immediate: true })
  async carregarNotasFiscaisExcluiveis() {
    if (!this.recebimento || !this.recebimento.notasFiscais || !this.recebimento.notasFiscais.length) {
      this.notasFiscaisExcluiveis = []
      return
    }

    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getNotasFiscaisExclusaoPermitida([this.recebimento.id])
    this.notasFiscaisExcluiveis = response.success && response.data ? response.data : []
  }

  get minimoDocumentosAdicionais() {
    return this.getRecebimento.acoes ? this.getRecebimento.acoes.minimoDocumentoAdicional : 0
  }

  get maximoDocumentosAdicionais() {
    return this.getRecebimento.acoes ? this.getRecebimento.acoes.maximoDocumentoAdicional : 10
  }

  openModalDadosNF(item: any) {
    this.getRecebimentoStore.setNFSelected(item)
    this.getRecebimentoStore.setModalDadosNF(true)
  }

  formatSituacao(situacao: string | undefined) {
    if (!situacao) return ''
    switch (situacao.toLowerCase()) {
      case 'divergente':
        return 'text--red-darken-2'
      case 'pendente':
        return 'text--yellow-darken-2'
      case 'paga':
        return 'text--green-darken-2'
      case 'pago':
        return 'text--green-darken-2'
      case 'validada':
        return 'text--green-darken-2'
      default:
        return ''
    }
  }

  getBadgeClass(situacao: string | undefined) {
    if (!situacao) return 'rc-badge-default'
    switch (situacao.toLowerCase()) {
      case 'divergente':
        return 'rc-badge-red'
      case 'pendente':
        return 'rc-badge-yellow'
      case 'paga':
      case 'pago':
        return 'rc-badge-green'
      default:
        return 'rc-badge-default'
    }
  }

  getSituacaoTooltipText({ situacao, acoes }: { situacao: string | undefined, acoes: any }) {
    if (!situacao) return ''
    switch (situacao.toLowerCase()) {
      case 'divergente':
        return 'A nota fiscal enviada está com divergências, foi encaminhado um e-mail com as divergências apontadas pela equipe do hospital, verifique os apontamentos, efetue a correção e encaminhe uma nota fiscal ajustada.'
      case 'pendente':
        return acoes.atualizar ? 'Utilize o botão abaixo para envio da sua nota fiscal.' : 'Pendente envio da nota fiscal pelo responsável.'
      case 'paga':
        return 'Este repasse foi marcado na situação \'Paga\' pela equipe do hospital, confirme o recebimento diretamente na conta bancária.'
      case 'pago':
        return 'Este repasse foi marcado na situação \'Pago\' pela equipe do hospital, confirme o recebimento diretamente na conta bancária.'
      default:
        return ''
    }
  }

  getsituacaoMultiplasNotasText({ situacao, nomeArquivoOriginal, acoes }: { situacao: string | undefined, nomeArquivoOriginal: string, acoes: any }) {
    let message = '';
    
    if (situacao){
      switch (situacao.toLowerCase()) {
        case 'divergente':
          message = 'A nota fiscal enviada está com divergências, foi encaminhado um e-mail com as divergências apontadas pela equipe do hospital, verifique os apontamentos, efetue a correção e encaminhe uma nota fiscal ajustada.'
        case 'pendente':
          message = this.getRecebimento.acoes.atualizar ? 'Utilize o botão abaixo para envio da sua nota fiscal.' : 'Pendente envio da nota fiscal pelo responsável.'
        case 'paga':
          message = 'Este repasse foi marcado na situação \'Paga\' pela equipe do hospital, confirme o recebimento diretamente na conta bancária.'
        case 'pago':
          message = 'Este repasse foi marcado na situação \'Pago\' pela equipe do hospital, confirme o recebimento diretamente na conta bancária.'
        default:
          message = ''
      }
    }

    if (nomeArquivoOriginal.endsWith('.xml')) {
     message += ' Ao excluir o arquivo PDF, o arquivo XML será excluido! ';
    }
    
    return message;
  }

  hasSituacao(situacao: string | undefined) {
    if (!situacao) return false
    return ['pendente', 'paga', 'pago', 'divergente'].includes(situacao.toLowerCase())
  }

  formatSituacaoText(situacao: string | undefined) {
    if (!situacao) return ''
    return situacao.charAt(0).toUpperCase() + situacao.slice(1).toLowerCase()
  }

  podeAbrirModalDadosNF(recebimento: Recebimento) {
    return recebimento.extratoDadosNfObrigatorios || recebimento.acoes.permiteNotaFiscalXml || recebimento.acoes.habilitaDocumentoAdicional
  }
  
  formatDate(date: string) {
    return maskDate(date)
  }

  formatDateMonth(date: string) {
    return maskDateMonth(date)
  }

  formatDateTime(date: string) {
    return maskDateTime(date)
  }

  formatMoney(value: any) {
    return maskMoney(value)
  }

  lowerCase(value: string) {
    return _.toLower(value)
  }

  async getValoresCalculados(id: string) {
    this.loadingValores = true
    await this.getRecebimentoStore.getValoresCalculados(id)
    this.valoresListDialog = true
    this.loadingValores = false
  }

  formatMoneyUtil(money: any) {
    return maskMoney(money)
  }

  closeValoresListDialog() {
    this.valoresListDialog = false
  }

  calcularValorLiquido() {
    const { valorBruto, descontos } = this.getRecebimento
    let valorLiquido = valorBruto

    // Percorrer a lista de descontos e subtrair o valor de cada desconto
    descontos.forEach((desconto) => {
      valorLiquido -= desconto.valorTotal
    })

    return this.formatMoneyUtil(valorLiquido)
  }

  async deletar(index) {
    let params: any = []
    
    const arquivo = this.recebimento.notasFiscais[index]
    const temArquivoXml = this.recebimento.notasFiscais.some((nf) => nf.nomeArquivoOriginal.endsWith('.xml'))
    const tipoArquivo = arquivo.nomeArquivoOriginal.split('.').pop()
    
    if(tipoArquivo === 'pdf' && temArquivoXml){
      this.loadingDeletar = true

      params = this.recebimento.notasFiscais.map((nf) => {
        return {
          prestadorRecebimentoId: nf.prestadorRecebimentoId,
          documentoId: nf.documentoId,
        }
      })
    } else {
      this.loadingDeletar = index

      params.push({
        prestadorRecebimentoId: arquivo.prestadorRecebimentoId,
        documentoId: arquivo.documentoId,
      })
    }
    
    try {
      for (const notaFiscal of params) {
        const response = await this.getRecebimentoStore.deletarDocumento(notaFiscal)

        if (response.success) {
          // PDF + XML apagam várias notas no mesmo laço: remover pelo documento, não pelo índice clicado
          const indexDaNota = this.recebimento.notasFiscais.findIndex(nf => nf.documentoId === notaFiscal.documentoId)
          if (indexDaNota >= 0) this.recebimento.notasFiscais.splice(indexDaNota, 1)
          EventBus.$emit('setSnackbar', {
            show: true,
            text: 'Nota Fiscal deletada com sucesso.',
            icon: 'done',
            color: '#2E7D32',
          })
        } else {
          EventBus.$emit('setSnackbar', {
            show: true,
            text: response.message || 'Houve um problema ao deletar a nota fiscal.',
            icon: 'warning',
            color: '#C62828',
          })
        }
      }
    } catch {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: 'Houve um problema ao deletar a nota fiscal.',
        icon: 'warning',
        color: '#C62828',
      })
    } finally {
      this.loadingDeletar = null
    }
  }

  async deletarDocumentoAdicional(arquivo, index) {
    if (this.minimoDocumentosAdicionais && ((this.recebimento.documentosAdicionais.length - 1) < this.minimoDocumentosAdicionais)) {
      EventBus.$emit('setSnackbar', {
        show: true,
          text: `Não é possível excluir este documento sem anexar outro. O mínimo exigido é ${this.minimoDocumentosAdicionais} documento(s) adicional(is).`,
          icon: 'warning',
          color: '#C62828',
        })

      return
    }
    
    this.loadingDeletarDocumento = index

    const notaFiscal = {
      prestadorRecebimentoId: arquivo.prestadorRecebimentoId,
      documentoId: arquivo.id,
    }
    const response = await this.getRecebimentoStore.deletarDocumentoAdicional(notaFiscal)
      
    setTimeout(() => {
      if (response.success) {
        this.recebimento.documentosAdicionais.splice(index, 1)
        EventBus.$emit('setSnackbar', {
          show: true,
          text: 'Documento Adicional deletado com sucesso.',
          icon: 'done',
          color: '#2E7D32',
        })
      } else {
        EventBus.$emit('setSnackbar', {
          show: true,
          text: 'Houve um problema ao deletar o documento adicional.',
          icon: 'warning',
          color: '#C62828',
        })
      }
      this.loadingDeletarDocumento = null
    }, 3000)
  }

  async download(arquivo: any) {
    const id = arquivo.documentoId ? arquivo.documentoId : arquivo.id
    const response = await this.getRecebimentoStore.download({ prestadorRecebimentoId: id })
    const win = window.open()
    // @ts-ignore
    win.document.body.style.margin = '0'
    // @ts-ignore
    win.document.body.style.padding = '0'
    // @ts-ignore
    const iframe = win.document.createElement('iframe')
    iframe.src = response.data
    iframe.setAttribute('frameborder', '0')
    iframe.setAttribute('allowfullscreen', '')
    // Estilo via cssText (CSSOM): a CSP herdada pela janela bloqueia atributo style inline
    iframe.style.cssText = 'border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%; margin:-8px;'
    // @ts-ignore
    win.document.body.appendChild(iframe)
    this.ga('recebimento-financeiro', 'download-nota-fiscal')
  }

  async downloadNF(arquivo: any, index: number) {
    this.loadingDownloadNf = `${arquivo.nomeArquivoOriginal}-${index}`
    const id = arquivo.documentoId ? arquivo.documentoId : arquivo.id
    
    const response = await this.getRecebimentoStore.download({ prestadorRecebimentoId: id })
    const ext = (arquivo.nomeArquivoOriginal || '').toLowerCase().endsWith('.xml') ? 'xml' : 'pdf'
    const type = ext === 'xml' ? 'application/xml' : 'application/pdf'
    const data = response.data
    const blob = typeof data === 'string' && data.startsWith('data:')
      ? await (await fetch(data)).blob()
      : new Blob([data], { type })
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = arquivo.nomeArquivoOriginal || `nota-fiscal.${ext}`
    document.body.appendChild(link)
    link.click()
    link.remove()
    window.URL.revokeObjectURL(url)

    this.loadingDownloadNf = null
  }

  async inputFile(newFile) {
    this.loadingAnexo = true

    // Verifica se o arquivo já foi identificado
    if (newFile.identifier) {
      return
    }

    const formData = new FormData()
    formData.append('notaFiscal', newFile.file)

    const params = {
      formData,
      prestadorRecebimentoId: this.recebimento.id,
    }

    const response = await this.getRecebimentoStore.uploadNotaFiscal(params)

    if (response.success) {
      this.getRecebimentoStore.setNomeArquivoOriginal(newFile.name)
      await this.getRecebimentoStore.loadRecebimentos()

      EventBus.$emit('setSnackbar', {
        show: true,
        text: 'Nota Fiscal enviada com sucesso.',
        icon: 'done',
        color: '#2E7D32',
      })
    } else {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: this.errorsMessage(response) || 'Houve um problema ao enviar nota fiscal.',
        icon: 'warning',
        color: '#C62828',
      })
    }

    this.loadingAnexo = false
    this.ga('recebimento-financeiro', 'enviar-nota-fiscal')
  }

  errorsMessage(mensagens: any) {
    // eslint-disable-next-line
    return mensagens.errors.reduce((target, source) => { target += source.message; return target }, '')
  }

  async abrirRecebimentoDetalhe(recebimento: Recebimento) {
    this.setLoadingRequest(true, this.getRequestMessage.init.text)
    await this.getRecebimentoStore.setRecebimento(recebimento)
    await this.getRecebimentoStore.loadRecebimentoItens()
    this.getRecebimentoStore.setModalRecebimentoDetalhes(true)
    this.clearLoadingRequest()
    this.ga('recebimento-financeiro', 'abrir-recebimento-detalhe')
  }

  showInstructions(item: any) {
    EventBus.$emit('instruirEmissaoDeNota', { open: true, instrucoes: { ...item } })
  }

  openModalInfoSituacao(item: any) {
    EventBus.$emit('infoSituacao', { open: true, item: { ...item } })
  }

  openModalInfoSituacaoMultipla(item: any) {
    EventBus.$emit('infoSituacaoMultipla', { open: true, item: { ...item } })
  }

  @Emit('setLoadingRequest')
  setLoadingRequest(status, text) { }

  clearLoadingRequest() {
    this.setLoadingRequest(false, '')
  }

  /**
   * Area do chat financeiro
   */

  get chatStore() {
    return getModule(ChatFinanceiroStore, this.$store)
  }

  async showChat() {
    const nomeGrupo = this.getRecebimento.id
    const hospitalId = this.getRecebimento.fontePagadoraId
    const identificador = this.getRecebimento.id
    const userId = this.$user.profile.sub

    EventBus.$emit('setLoadingRequest', { status: true, text: 'Aguardando conexão...' })

    // this.chatStore.reset()
    await this.chatStore.openChatModalMedic({
      userId,
      nomeGrupo,
      hospitalId,
      ehUsuarioAtendimento: false,
      identificador,
      mensagem: '',
      recebimento: this.getRecebimento,
    })
  }

  getChatInfo(params: any) {
    const { totalMensagensNaoLidas = 0 } = params

    if (totalMensagensNaoLidas > 0) {
      const number = totalMensagensNaoLidas >= 1 ? totalMensagensNaoLidas : ''
      const text = totalMensagensNaoLidas > 1 ? 'Novas Mensagens' : 'Nova Mensagem'

      return { icon: 'chat', title: `${number} ${text}`, class: '-orange' }
    }

    return { icon: 'chat', title: 'Chat Aberto', class: '-yellow' }
  }
}
